(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lab-reports"] && !Shopify.designMode) return;
  try {
    class LabPopupGate extends HTMLElement {
    connectedCallback() {
      // Move the overlay to <body> so no parent can hide or clip it
      this.overlay = document.getElementById('lab-popup-overlay');
      document.body.appendChild(this.overlay);

      // Block the Escape key while the popup is open
      document.addEventListener('keydown', (e) => {
        if (!this.overlay.hidden && e.key === 'Escape') {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      // Download button click shows the overlay, the open event is a backup
      this.addEventListener('click', () => this.show());
      this.addEventListener('open', () => this.show(), true);
      this.addEventListener('close', () => { this.overlay.hidden = true; }, true);
    }

    show() {
      this.overlay.hidden = false;
      // The popup renders just after the click, so apply styles a few times
      [0, 100, 300, 800].forEach((ms) => setTimeout(() => this.applyStyles(), ms));
    }

    applyStyles() {
      const root = this.querySelector('shopify-account').shadowRoot;
      if (!root) return;

      let style = root.getElementById('lr-style');
      if (!style) {
        style = document.createElement('style');
        style.id = 'lr-style';
        root.appendChild(style);

        // Clicking the dialog backdrop must not close the popup
        root.addEventListener('click', (e) => {
          if (e.composedPath()[0].tagName === 'DIALOG') {
            e.stopPropagation();
            e.preventDefault();
          }
        }, true);
      }

      style.textContent = document.getElementById('lab-popup-css').textContent;

      // Block closing with the Escape key
      root.querySelectorAll('dialog').forEach((dialog) => {
        dialog.oncancel = (e) => e.preventDefault();
      });
    }
  }

  if (!customElements.get('lab-popup-gate')) {
    customElements.define('lab-popup-gate', LabPopupGate);
  }
  } catch(e) { console.error(e); }
})();

})();
